import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
    en: {
        translation: {
            Search: 'Search',
            Back: 'Back',
        },
    },
    pl: {
        translation: {
            Search: 'Szukaj',
            'Search engine': 'Wyszukiwarka',
            'About search engine': 'O wyszukiwarce',
            Rules: 'Zasady',
            Back: 'Wróć',
            'Loading...': 'Ładuję...',
            'Error while downloading answer. Please reload page and try again':
                'Wystąił błąd podczas pobierania odpowiedzi. Przeładuj stronę i spróbuj ponownie',
            'No results for entered query': 'Brak rezultatów dla podanej frazy',
            'An error occurred while downloading answer, please try again or reload page':
                'Podczas ładowania odpowiedzi wystąpił błąd, spróbuj ponownie lub przeładuj stronę',
            Name: 'Nazwa',
            'Composition of the compound': 'Skład mieszaniny',
            Percentage: 'Zawartość w mieszaninie',
            _Name: 'Nazwie',
            'KB name': 'Nazwa w Krajowej bazie',
            'KB name info':
                'Nazwa substancji w Wykazie gazów cieplarnianych i innych substancji wprowadzanych do powietrza objętych systemem zarządzania emisjami gazów cieplarnianych i innych substancji, stanowiącym załącznik nr 1 do ustawy z dnia 17 lipca 2009 r. o systemie zarządzania emisjami gazów cieplarnianych i innych substancji',
            'Other names': 'Inne nazwy',
            Formula: 'Wzór sumaryczny',
            Index: 'Indeks',
            'Search by': 'Szukaj po',
            'CAS number': 'Numerze CAS',
            CAS: 'Nr CAS',
            'CAS info':
                'Oznaczenie numeryczne substancji według Chemical Abstracts Service',
            Action: 'Akcja',
            'Report changes': 'Zgłoś propozycję zmiany',
            USZE: 'Nr pozycji w Krajowej bazie',
            'USZE info':
                'Liczba porządkowa (lp.) substancji w Wykazie gazów cieplarnianych i innych substancji wprowadzanych do powietrza objętych systemem zarządzania emisjami gazów cieplarnianych i innych substancji, stanowiącym załącznik nr 1 do ustawy z dnia 17 lipca 2009 r. o systemie zarządzania emisjami gazów cieplarnianych i innych substancji',
            'Charging system number': 'Nr pozycji na liście opłat',
            'Charging system number info':
                'Liczba porządkowa (lp.) gazów lub pyłów wprowadzanych do powietrza określonych w Tabeli A załącznika nr 1 do rozporządzenia Rady Ministrów z dnia 22 grudnia 2017 r. w sprawie jednostkowych stawek opłat za korzystanie ze środowiska',
            'Charging system name': 'Nazwa w systemie opłat',
            'Charging system name info':
                'Nazwa gazu lub pyłów wprowadzanych do powietrza określonych w Tabeli A załącznika nr 1 do rozporządzenia Rady Ministrów z dnia 22 grudnia 2017 r. w sprawie jednostkowych stawek opłat za korzystanie ze środowiska',
            'You can report to us new substances or suggestion about changes':
                'Możesz zgłosić do nas nowe substancje lub zmiany poprzez wysłanie poniższego formularza',
            'Your report were sent': 'Twoje zgłoszenie zostało wysłane',
            'Email address': 'Adres email',
            'Substance name': 'Nazwa substancji',
            'Process type': 'Rodzaj procesu',
            'Describe your case': 'Dodatkowe uwagi',
            Submit: 'Wyślij',
            Select: 'Wybierz',
            Close: 'Zamknij',
            'Copied!': 'Skopiowano do schowka!',
            'Thank you for reporting suggestions, we will reach you as soon as possible':
                'Dziękujemy za wysłanie zgłoszenia! Rozpatrzymy je jak najszybciej będzie to możliwe.',
            'No results': 'Brak wyników',
            'You can report suggestion for changes or new substances by clicking link below':
                'Możesz zgłosić nowe substancje lub propozycje zmian klikając w poniższy button',
            Report: 'Zgłoś substancję',
            'Type name': 'Wpisz nazwę',
            'Type CAS number': 'Wpisz numer CAS',
            'Back to search': 'Wróć do wyszukiwarki',
            'Field is required': 'Pole jest wymagane',
            'The email address is incorrect': 'Adres emial jest nie poprawny',
            'I got acquainted with': 'Zapoznałem się',
            'information clause on the processing of personal data':
                'klauzulą informacyjną o przetwarzaniu danych osobowych',
            'Fields marked * are required': 'Pola oznaczone * są wymagane',
        },
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: 'pl',
    keySeparator: false,
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
